<template>
    <!-- IE 2026 09 08 / ODOO-… (заказ Игоря): полоса парковки свободных виджетов (режим 'park', utils/freeWidgets.js) —
         чипы у нижнего края экрана: наведение показывает виджет целиком, клик возвращает его наверх.
         Здесь же — глобальный CSS всех режимов поведения свободных виджетов (атрибуты data-fw*). -->
    <teleport to="body">
        <div v-if="st.parked.length" class="fw-strip" @mousedown.stop>
            <!-- IE 2026 09 23 / ODOO-341407: i18n -->
            <div class="fw-strip-title" v-uiHelp="'topbar.parked'">{{ t('Parked') }}</div>
            <div v-for="it in st.parked" :key="it.id" class="fw-strip-chip" v-uiHelp="'topbar.parked.chip'" :data-fw-id="'WIDGET' + it.id"
                :title="t('{title} — click to bring back', { title: it.title })"
                @mouseenter="peek(it, true)" @mouseleave="peek(it, false)" @click.stop="unpark(it)">
                <span class="fw-chip-icon"><i :class="it.pi"></i></span>
                <span class="fw-chip-label">{{ it.title }}</span>
            </div>
        </div>
    </teleport>
</template>

<script>
import freeWidgets from '@/utils/freeWidgets'

export default {
    name: 'FreeWidgetsStrip',
    data() {
        return { st: freeWidgets.state }
    },
    methods: {
        peek(it, on) { freeWidgets.peekParked(it, on) },
        unpark(it) { freeWidgets.unpark(it) },
    },
}
</script>

<style>
/* IE 2026 09 08 / ODOO-… (заказ Игоря): режимы поведения свободных виджетов при активном докированном.
   z-порядок: свободные 900+ (popout_baseZ) < докированный-сверху 1300 < peek 1350 < Alt+Tab lift 1400 <
   wijmo-попапы/подсказки 1500. Атрибуты ставит utils/freeWidgets.js. */

/* A 'front': активный докированный поднят над свободными */
.WIDGET[data-fw-front] { z-index: 1300 !important; }

/* B 'ghost' и C 'outline': тело не ловит клики (уходят в докированный под ним), шапка живая */
.WIDGET[data-fw="ghost"]:not([data-fw-peek]),
.WIDGET[data-fw="outline"]:not([data-fw-peek]) { pointer-events: none; }
.WIDGET[data-fw="ghost"]:not([data-fw-peek]) .widget-container > *,
.WIDGET[data-fw="outline"]:not([data-fw-peek]) .widget-container > * { pointer-events: auto; }

/* B 'ghost': призрак */
.WIDGET[data-fw="ghost"]:not([data-fw-peek]) { opacity: .3; }

/* C 'outline': контур — рамка цвета гаммы + шапка, тело невидимо, фон прозрачный */
.WIDGET[data-fw="outline"]:not([data-fw-peek]) {
    background: transparent !important;
    box-shadow: none !important;
    outline: 2px solid var(--cs-accent, #6477ef);
    outline-offset: -2px;
}
/* всё, кроме шапки (.widget-container), невидимо — вместе с потомками И псевдоэлементами: у подчёркивания
   активной вкладки wijmo (.wj-tabheader.wj-state-active::after) visibility: visible задана явно и не наследуется —
   без этих правил чёрточка оставалась на экране */
.WIDGET[data-fw="outline"]:not([data-fw-peek]) > :not(.widget-container),
.WIDGET[data-fw="outline"]:not([data-fw-peek]) > :not(.widget-container) *,
.WIDGET[data-fw="outline"]:not([data-fw-peek]) > :not(.widget-container) *::before,
.WIDGET[data-fw="outline"]:not([data-fw-peek]) > :not(.widget-container) *::after { visibility: hidden !important; }
.WIDGET[data-fw="outline"]:not([data-fw-peek]) .widget-container {
    background: var(--surface-card, #fff);
    border-radius: .5rem .5rem 0 0;
}

/* D 'shade': свёрнут до строки шапки на своём месте (высота — из JS, --fw-shade-h) */
.WIDGET[data-fw="shade"]:not([data-fw-peek]) {
    height: var(--fw-shade-h, 40px) !important;
    min-height: 0 !important;
    overflow: hidden !important;
}
.WIDGET[data-fw="shade"]:not([data-fw-peek]) > :not(.widget-container),
.WIDGET[data-fw="shade"]:not([data-fw-peek]) > :not(.widget-container) *,
.WIDGET[data-fw="shade"]:not([data-fw-peek]) > :not(.widget-container) *::before,
.WIDGET[data-fw="shade"]:not([data-fw-peek]) > :not(.widget-container) *::after { visibility: hidden !important; }

/* E 'park': контейнер скрыт, виджет представлен чипом в полосе */
.WIDGET[data-fw="park"]:not([data-fw-peek]),
.WIDGET[data-fw="park"]:not([data-fw-peek]) *,
.WIDGET[data-fw="park"]:not([data-fw-peek]) *::before,
.WIDGET[data-fw="park"]:not([data-fw-peek]) *::after { visibility: hidden !important; pointer-events: none !important; }

/* peek: показать целиком поверх остальных на время наведения */
.WIDGET[data-fw][data-fw-peek] { z-index: 1350 !important; }

/* полоса парковки */
.fw-strip {
    position: fixed;
    left: 50%;
    bottom: 10px;
    transform: translateX(-50%);
    z-index: 1400;
    display: flex;
    align-items: center;
    gap: 8px;
    max-width: 92vw;
    overflow-x: auto;
    padding: 6px 10px;
    border-radius: 14px;
    background: rgba(209, 216, 249, .55);
    -webkit-backdrop-filter: blur(12px);
    backdrop-filter: blur(12px);
    box-shadow: 0 6px 22px rgba(0, 0, 0, .22);
}
.fw-strip-title {
    font-size: .75rem;
    font-weight: 800;
    letter-spacing: .08em;
    text-transform: uppercase;
    color: var(--text-color-secondary, #6c757d);
    opacity: .75;
    padding: 0 4px;
    white-space: nowrap;
}
.fw-strip-chip {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px 4px 4px;
    border-radius: 10px;
    background: #d1d8f9;
    color: var(--text-color-secondary, #495057);
    cursor: pointer;
    white-space: nowrap;
    max-width: 260px;
}
.fw-strip-chip:hover { outline: 2px solid var(--cs-accent, #6477ef); outline-offset: -2px; }
.fw-strip-chip .fw-chip-icon {
    width: 26px;
    height: 26px;
    flex: none;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background-color: #6476ef3e;
    color: var(--primary-color-text, #fff);
}
.fw-strip-chip .fw-chip-icon i { font-size: 14px; }
.fw-strip-chip .fw-chip-label { overflow: hidden; text-overflow: ellipsis; }
</style>
